import {
  ActionValidation,
  ConfigOptionValidation,
  StringValidation,
} from '../../../utils/component-validations';
import { fn } from '@ember/helper';
import { isEmpty } from '@ember/utils';
import { on } from '@ember/modifier';
import { or } from 'ember-truth-helpers';
import CloseButton from '../action/button/close.gjs';
import Container from '../core/container.gjs';
import GhostButton from '../action/button/ghost.gjs';
import Super from '../core/base.gjs';
import styles from './message.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const ERROR = 'error';
const SUCCESS = 'success';
const SYSTEM = 'system';
const SUPPORTED_TYPES = [ERROR, SUCCESS, SYSTEM];

export default class SpdsToastMessage extends Super {
  arguments = [
    new ConfigOptionValidation({
      required: [
        {
          name: 'toast.type',
          options: SUPPORTED_TYPES,
        },
      ],
    }),
    new StringValidation({ required: ['toast.message'] }),
  ];
  baseClass = 'spds-toast-message';
  classesToMapToAttrs = ['hasCta', 'type'];
  componentName = 'Spds::Toast::Message';
  styles = styles;

  get hasCta() {
    return !isEmpty(this.args.toast.cta);
  }

  get type() {
    return this.args.toast.type;
  }

  get icon() {
    let { type } = this;
    let icon;

    switch (type) {
      case ERROR:
        icon = 'triangle-exclamation-mark';
        break;
      case SUCCESS:
        icon = 'circle-check';
        break;
      case SYSTEM:
        icon = 'circle-i';
        break;
      default:
        icon = null;
    }

    return icon;
  }

  constructor() {
    super(...arguments);

    let { cta } = this.args;

    if (cta) {
      this.arguments.push(
        new ActionValidation({ required: ['cta.action'] }),
        new StringValidation({ required: ['cta.text'] })
      );
    }
  }

  ctaClick = async () => {
    let shouldClose = await Promise.resolve(this.args.toast.cta.action?.());

    if (shouldClose || isEmpty(shouldClose)) {
      this.args.onManualDismiss?.(this.args.toast);
    }
  };

  <template>
    <Container
      @tag="li"
      aria-live="assertive"
      class={{this.classes}}
      data-test-spds-toast-message={{or @index "0"}}
      role="status"
      {{this.validateArguments}}
      ...attributes
    >
      {{#if this.icon}}
        {{svgJar this.icon class="icon" data-test-spds-toast-message-icon=""}}
      {{/if}}
      <Container class="text" data-test-spds-toast-message-text>
        {{@toast.message}}
      </Container>
      {{#if @toast.cta}}
        <GhostButton
          class="cta-btn"
          data-test-spds-toast-message-cta-button
          type="button"
          {{on "click" this.ctaClick}}
        >
          {{@toast.cta.text}}
        </GhostButton>
      {{/if}}
      <CloseButton
        @close={{fn @onManualDismiss @toast}}
        class="dismissal-btn"
        data-test-spds-toast-message-close-button
      />
    </Container>
  </template>
}
